import { z } from 'zod';

export const DESCRIPTION_MAX_LENGTH = 6000;

export const getDescriptionPlaintextLength = (html: string): number => {
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  return (parsed.body.textContent ?? '').length;
};

export const descriptionSchema = z
  .string()
  .refine((value) => getDescriptionPlaintextLength(value) <= DESCRIPTION_MAX_LENGTH);
